var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdrBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.66797L17.5 5.83464V17.5081C17.5 17.9646 17.1292 18.3346 16.6722 18.3346H3.32783C2.87063 18.3346 2.5 17.9552 2.5 17.5081V2.49447C2.5 2.03801 2.87079 1.66797 3.32783 1.66797H13.3333ZM10 9.58464C11.1506 9.58464 12.0833 8.65189 12.0833 7.5013C12.0833 6.35071 11.1506 5.41797 10 5.41797C8.84942 5.41797 7.91667 6.35071 7.91667 7.5013C7.91667 8.65189 8.84942 9.58464 10 9.58464ZM6.27288 14.168H13.7271C13.5198 12.293 11.9303 10.8346 10 10.8346C8.06977 10.8346 6.48016 12.293 6.27288 14.168Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdrBlack);
export default __webpack_public_path__ + "static/media/odr-black.4d74fdfa67cf8e3b6d90cb0515259d24.svg";
export { ForwardRef as ReactComponent };